module.exports = __webpack_public_path__ + "static/media/close-rounded.ae0cd299.svg";